<template>
  <div class="pulse-boeble"></div>
</template>
<script setup lang="ts"></script>
<style scoped>
.pulse-boeble {
  position: relative;
  width: calc(var(--spacer) * 3);
  height: calc(var(--spacer) * 3);
  border-radius: 50%;
  background: var(--moin-color-success);
}

@keyframes pulse {
  0% {
    transform: scale(0.5);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}

.pulse-boeble::after {
  content: ' ';
  position: absolute;
  top: 0;
  left: 0;
  margin-left: calc(var(--spacer) * -1.5);
  margin-top: calc(var(--spacer) * -1.5);
  width: calc(var(--spacer) * 6);
  height: calc(var(--spacer) * 6);
  background: var(--moin-color-success);
  opacity: 0.5;
  border-radius: 50%;
  animation: pulse 1s infinite;
}
</style>
